module.exports = __webpack_public_path__ + "img/8.9b3534b1.png";